import React from 'react'
import { Linking } from 'react-native'
import Config from 'react-native-config'
import { useNavigation } from '@react-navigation/native'
import { useNavigateToByosCheckout } from '@screens/Marketplace/utils/hooks.ts'
import { Analytics, CustomEventTypes } from '@src/config'
import { BaseSubscriptionOptions } from './BaseSubscriptionOptions'

export const SubscriptionOptions = () => {
  const { navigateToByosCheckout } = useNavigateToByosCheckout()
  const navigation = useNavigation()

  const onOwnSensorPress = () => {
    navigateToByosCheckout()
  }

  const onPurchaseSensorPress = () => {
    navigation.navigate('SteloSelectSubscription')
  }

  const onVideoCallsPress = async () => {
    try {
      Analytics.track(CustomEventTypes.GettingStartedVideoCallsPress)
      await Linking.openURL(
        `${Config.WEB_MEMBERS_BASE_URL}/video-calls?utm_source=mobile-app&utm_campaign=getting-started`,
      )
    } catch (error) {
      console.error('Error opening video calls URL:', error)
    }
  }

  return (
    <BaseSubscriptionOptions
      title="Programs"
      onOwnSensorPress={onOwnSensorPress}
      onPurchaseSensorPress={onPurchaseSensorPress}
      onVideoCallsPress={onVideoCallsPress}
    />
  )
}
